'use strict';

import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

import $global from '../globalElements';
import utilities from '../utilities';

import manufacturerTemplate from '../../tmpl/pages/manufacturers/_manufacturers-list.hbs';
import lineCardsTemplate from '../../tmpl/pages/manufacturers/_linecards.hbs';

Backbone.$ = $;

var Router = Backbone.Router.extend({

    // Update URL.
    userTrigger: function(targetId) {
      var url = window.location.pathname.substr();
      if (targetId === 'popular') {
        //Default view doesn't need tab parameter in the URL
        this.navigate(url, {trigger: false});
      } else {
        this.navigate(url + '?tab=' + targetId, {trigger: false});
      }
    }

  }),

  ManufacturerRouter = new Router();

module.exports = ManufacturerRouter;

var ManufacturersTabs = Backbone.View.extend({

  events: {
    'click .ManufacturersTabs-tab': 'onTabClick',
    'click .js-ManufacturersTabs-listView': 'toggleView',
    'click .js-ManufacturersTabs-gridView': 'toggleView',
    'focus .sub-menu-link': 'onTabFocus',
    'blur .ManufacturersTabs-tab-link-subcategory': 'onTabBlur',
    'focus #link_ZeroToNine': 'onSubMenuBlur',
    'focus .js-ManufacturersTabs-gridView': 'onTabFocus',
    'keydown .ManufacturersTabs-tab-link': 'onKeydown',
    'keydown .ManufacturersTabs-tab-link': 'onKeydownTab'
  },

  initialize: function() {
    if (!this.$el.length) return false;
    if (Backbone.history && !Backbone.History.started) {
      Backbone.history.start({ pushState: Modernizr.history, silent: true });
    }

    this.$icons = $('.ManufacturersTabs-results-icons');

    if (window.bootstrappedManufacturerList) {
      this.dataJson = window.bootstrappedManufacturerList;
    } else {
      this.dataJson = [];
    }

    this.$list = $('.manufacturer-section');
  },

  linecardsIconHide: function() {
    if (this.$('.ManufacturersTabs-results-section--is-active').attr('id') === 'linecards') {
      this.$icons.hide();
    } else {
      this.$icons.show();
    }
  },

  toggleView: function(e) {
    var $clickedButton = $(e.target),
      targetView = $clickedButton.data('viewtype'),
      $results = this.$('.ManufacturersTabs-results');

    this.$('.ManufacturersTabs-results-icons--is-active').attr('aria-pressed', 'false');
    this.$('.ManufacturersTabs-results-icons--is-active').removeClass('ManufacturersTabs-results-icons--is-active');
    $clickedButton.addClass('ManufacturersTabs-results-icons--is-active');
    $clickedButton.attr('aria-pressed', 'true');

    if (targetView === 'grid') {
      $results.removeClass('ManufacturersTabs-results--is-list');
      $results.addClass('ManufacturersTabs-results--is-grid');

      $global.$window.trigger('scroll'); // this is used to trigger the lazy loading for of lazy load
    }

    else if (targetView === 'list') {
      $results.removeClass('ManufacturersTabs-results--is-grid');
      $results.addClass('ManufacturersTabs-results--is-list');
    }
  },


  getFilteredElements: function(data, filterName) {

    data = data.data;
    let filteredcollection;

    if (filterName === 'showall') {
      filterName = 'manufacturers';
    }

    // eslint-disable-next-line no-unused-vars
    for (let key in data) {
      if (data.hasOwnProperty(key) && key === filterName) {
        if (!_.isArray(data[key])) {
          filteredcollection = [data[key]];
        } else {
          filteredcollection = data[key];
        }
      }
    }

    if (!filteredcollection) {
      if (filterName === 'new') {
        let newElements = [];
        // eslint-disable-next-line no-unused-vars
        for (let mfr in data.manufacturers) {
          let item = data.manufacturers[mfr];
          if (item.manufacturers) {
            _.filter(item.manufacturers, function(item2) {
              if (item2.isNew === true) {
                newElements.push(item2);
              }
            });
          }
        }
        filteredcollection = [{
          listTitle: 'New',
          manufacturers: newElements
        }];
      } else if (filterName === 'instock') {
        let collection = [];
        // eslint-disable-next-line no-unused-vars
        for (let mfr in data.manufacturers) {
          let instockElements = [];
          let item = data.manufacturers[mfr];
          if (item.manufacturers) {
            _.filter(item.manufacturers, function(item2) {
              if (item2.productCount && (parseInt(item2.productCount) !== 'NaN')) {
                parseInt(item2.productCount);
                instockElements.push(item2);
              }
            });
            if (instockElements.length > 0) {
              collection.push(
                {
                  listTitle: data.manufacturers[mfr].listTitle,
                  manufacturers: instockElements
                }
              );
            }
          }
        }
        filteredcollection = collection;
      } else if (data && data.manufacturers) {
        filteredcollection = _.filter(data.manufacturers, function(item) {
          if (item.listTitle === filterName) {
            return item;
          }
        });
      }
    }

    this.toggleSearchElements(filterName);
    return filteredcollection;
  },

  toggleSearchElements: function(filterName) {

    if (filterName === 'manufacturers') {
      filterName = 'showall';
    }

    $('.ManufacturersTabs-tab-link').removeClass('ManufacturersTabs-tab-link--is-selected');
    $('.ManufacturersTabs-tab-link').removeAttr('aria-current');
    $('.ManufacturersTabs-tab-link').removeAttr('aria-selected');
    _.each($('.ManufacturersTabs-tab-link'), function(el) {
      let menuItem = $(el);
      if (menuItem.data('target') === filterName) {
        menuItem.addClass('ManufacturersTabs-tab-link--is-selected');
        menuItem.attr('aria-current',true);
        menuItem.attr('aria-selected',true);
        if (menuItem.hasClass('ManufacturersTabs-tab-link-subcategory')) {
          let parentTab = menuItem.closest('.parent-menu').find('> .ManufacturersTabs-tab-link');
          parentTab.addClass('ManufacturersTabs-tab-link--is-selected');
          parentTab.attr('aria-current',true);
          parentTab.attr('aria-selected',true);
          parentTab.attr('data-value',filterName);
        }
      }
    });
  },

  onTabClick: function(e) {
    e.preventDefault();

    let $clickedTab = $(e.target),
      targetId = $clickedTab.data('target'),
      parentTab = $clickedTab.closest('.parent-menu').find('> .ManufacturersTabs-tab-link');

    if (utilities._isMobileOrTabletDevice()) {
      let $contentUl = $('.ManufacturersTabs-nav').find('> .Content');
      if ($($clickedTab[0]).hasClass('sub-menu-link')) {
        $($contentUl).addClass('mobile-nav');
      } else {
        $($contentUl).removeClass('mobile-nav');
      }
    }

    if (!targetId) return;

    let filteredList = this.getFilteredElements(this.dataJson, targetId);
    let $manufacturersTabs = $('#ManufacturersTabs.ReferenceDesign-browseTab');
    let $manufacturerGrid = $manufacturersTabs && $manufacturersTabs.length > 0 ? $manufacturersTabs.find('.ManufacturersTabs-results--is-grid') : null;

    if (targetId === 'linecards') {
      $('.manufacturer-section').attr('aria-labelledby', 'tab_lineCard');
      this.$list.html(lineCardsTemplate({
        lineCards: filteredList,
        totalLineCards: this.dataJson.data.totalLinecards
      }));
    } else if ($manufacturerGrid && $manufacturerGrid.length > 0) {
      let activeItem = $('.ManufacturersTabs-results-section--is-active');
      activeItem.removeClass('ManufacturersTabs-results-section--is-active');
      _.each($('.ManufacturersTabs-results-section'), function(el) {
        if (el.id === targetId) {
          $(el).addClass('ManufacturersTabs-results-section--is-active');
        }
      });
    }
    else {
      if (targetId === 'popular')
        $('.manufacturer-section').attr('aria-labelledby', 'tab_popular');
      else if (targetId === 'instock')
        $('.manufacturer-section').attr('aria-labelledby', 'tab_inStock');
      else if (targetId === 'showall')
        $('.manufacturer-section').attr('aria-labelledby', 'tab_showAll');
      else if (targetId === 'new')
        $('.manufacturer-section').attr('aria-labelledby', 'tab_new');
      this.$list.html(manufacturerTemplate({
        collection: filteredList
      }));
    }

    $('.parent-menu').find('> .ManufacturersTabs-tab-link').attr('data-value', '');

    $('.ManufacturersTabs-tab-link').removeClass('ManufacturersTabs-tab-link--is-selected');
    $('.ManufacturersTabs-tab-link').removeAttr('aria-current');
    $clickedTab.addClass('ManufacturersTabs-tab-link--is-selected');
    $clickedTab.attr('aria-current',true);
    $clickedTab.attr('aria-selected',true);
    // If clicked tab is same as current
    $clickedTab.closest('.parent-menu').find('> .ManufacturersTabs-tab-link').attr('data-value',targetId);
    if (parentTab.hasClass('ManufacturersTabs-tab-link--is-selected')) {
      return;
    }

    parentTab.addClass('ManufacturersTabs-tab-link--is-selected');
    parentTab.attr('aria-current',true);
    parentTab.attr('aria-selected',true);
    this.linecardsIconHide();
    ManufacturerRouter.userTrigger(targetId);

    $global.$window.trigger('scroll'); // this is used to trigger the lazy loading for of lazy load
  },

  onTabFocus: function(e) {
    e.preventDefault();

    let $clickedTab = $(e.target),
      siblingTab = $clickedTab.closest('.parent-menu').find('> .ManufacturersTabs-tab-link-sub-menu');

    $('.sub-menu-link').attr('aria-expanded', 'false');
    $('.ManufacturersTabs-tab-link-sub-menu').css('display', 'none');
    if (siblingTab) {
      $clickedTab.on('focus', function() {
        siblingTab.css({'display': 'flex','min-width': '155px'});
        $clickedTab.attr('aria-expanded', 'true');
      });
    }
  },

  onTabBlur: function(e) {
    e.preventDefault();
    let $clickedTab = $(e.target),
      siblingTab = $clickedTab.closest('.parent-menu').find('> .ManufacturersTabs-tab-link-sub-menu');
    if (!siblingTab)
    {
      $('.sub-menu-link').attr('aria-expanded', 'false');
      $('.ManufacturersTabs-tab-link-sub-menu').css('display', 'none');
    }
  },

  onSubMenuBlur: function(e) {
    e.preventDefault();
    $('.sub-menu-link').attr('aria-expanded', 'false');
    $('.ManufacturersTabs-tab-link-sub-menu').css('display', 'none');
  },

  cancelEvent: function(e) {
    e = e || window.event;
    if (e !== null) {
      if (e.cancelBubble) {
        e.cancelBubble = true;
      }
      e.preventDefault();
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  },

  setFocusOnFirst: function($target) {
    const FOCUSABLE_ELEMENT_SELECTORS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
    const focusableElements = this.$list[0].querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
      if (focusableElements[0].getAttribute('eventAdded') === null) {
        focusableElements[0].setAttribute('eventAdded', 1);
        const that = this;
        $(focusableElements[0]).on('keydown', function(e) {
          let keyCode = e.keyCode || e.which;
          if (e.shiftKey && keyCode === 9) {
            const focusElm = $target[0];
            setTimeout(() => { focusElm.focus(); }, 1);
            that.cancelEvent(e);
          }
        });
      }
    }
  },

  onKeydown: function(event) {
    var $newTarget = null;
    var $target = $(event.currentTarget);
    let siblings = $target.parent('li').parent().find('li[no-role="tab"]');
    if (siblings.length) {
      let first = $(siblings[0]).find('a.ManufacturersTabs-tab-link');
      if (first.length) {
        first[0].setAttribute('first', 1);
        let last = $(siblings[siblings.length - 1]).find('a.ManufacturersTabs-tab-link');
        last[0].setAttribute('last', 1);
        switch (event.key) {
          case 'ArrowLeft':
            if ($target.attr('first') && ($target.attr('first') === first.attr('first')))
              $newTarget = last;
            else {
              var $prev = $target.parent().prev();
              if ($prev && $prev.length) {
                if ($prev.find('.ManufacturersTabs-tab-no-link').length)
                  $prev = $prev.prev();
                $newTarget = $prev.find('a.ManufacturersTabs-tab-link');
              }
            }
            break;
          case 'ArrowRight':
            if ($target.attr('last') && ($target.attr('last') === last.attr('last')))
              $newTarget = first;
            else {
              var $next = $target.parent().next();
              if ($next && $next.length) {
                if ($next.find('.ManufacturersTabs-tab-no-link').length)
                  $next = $next.next();
                $newTarget = $next.find('a.ManufacturersTabs-tab-link');
              }
            }
            break;
          case 'Enter':
            // check if enter press on not selected
            if (!$target.attr('aria-current')) {
              $target.click();
            }

            if (!$target.attr('aria-haspopup')) {
              const that = this;
              setTimeout(() => { that.setFocusOnFirst($target); }, 1);
            }
            this.cancelEvent(event);
            break;
        }
        if ($newTarget) {
          $newTarget.focus();
          $newTarget.click();
          this.cancelEvent(event);
        }
      }
    } else {
      // keydown on submenu link
      if ($target.hasClass('ManufacturersTabs-tab-link-subcategory') || $target.attr('id') === 'link_ZeroToNine') {
        if (event.key === 'Enter') {
          $target.focus();
          $target.click();
          const that = this;
          setTimeout(() => { that.setFocusOnFirst($target); }, 1);
          this.cancelEvent(event);
        }
      }
    }
  },


  onKeydownTab: function(event) {
    var $newTarget = null;
    var $target = $(event.currentTarget);
    if (event.key === 'ArrowDown') {
      $newTarget = $target.parent().children()[1].children[0].children[0];
    }
    if (event.key === 'ArrowUp') {
      $newTarget = $target.parent().parent().siblings();
    }
    if ($newTarget) {
      $newTarget.focus();
    }
  }
});

module.exports = ManufacturersTabs;



// WEBPACK FOOTER //
// ./assets/js/manufacturers/manufacturers-tabs.js